<template>
  <Page
    :locked="false"
    :title="'Assine o plano de email'"
    :message="'Mantenha a sua lista de clientes engajados com a nossa plataforma robusta de envio de email marketing e de conteúdo.'"
    :features="features"
    :featureTitle="'O que tem no Email?'"
  >
    <div class="content">
      <PageHeader :breadcrumbLinks="breadcrumbLinks" title="E-Mail" :subtitle="$tc('generic-str.menu.domains', 2)">
        <template v-slot:actions>
          <li>
            <ButtonComponent variant="primary" v-modal="{ target: 'create-domain' }">
              <span class="material-symbols-outlined">
                add
              </span>
            </ButtonComponent>
          </li>
        </template>
      </PageHeader>
      <div class="page-content container-fluid">
        <TableComponent :fields="fields" :items="domains" :busy="loading">
          <template #cell(valid)="slotProps">
            <span v-if="slotProps.data == true" class="badge badge-success">{{ $t('generic-str.status.lbl-valid') }}</span>
            <span v-if="slotProps.data == false" class="badge badge-danger">{{ $t('generic-str.status.lbl-non-valid') }}</span>
          </template>
          <template #cell(actions)="slotProps">
            <DropdownComponent no-caret variant="link">
              <template #button>
                <span class="material-symbols-outlined">more_horiz</span>
              </template>
              <a class="dropdown-item" href="javascript:void(0)" v-modal="{ target: 'domain-validate', data: slotProps.item }" @click="verify(slotProps.item)">{{ $t('domain.verify') }}</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="remove(slotProps.item.id)">{{ $t('generic-str.remove') }}</a>
            </DropdownComponent>
          </template>
        </TableComponent>
        <br />
        <pagination :totalPages="pages" v-model="currentPage" @change="fetch" />
      </div>
      <create-domain-modal id="create-domain"></create-domain-modal>
      <domain-validate-modal id="domain-validate"></domain-validate-modal>
    </div>
  </Page>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/rebranding/PageHeader.vue';
import Pagination from '@/components/PaginationComponent.vue';
import MailService from '@/services/mail.service';
import CreateDomainModal from '@/components/mails/CreateDomainModal.vue';
import DomainValidateModal from '@/components/mails/DomainValidateModal.vue';
import Swal from 'sweetalert2';
import Page from '@/components/Page.vue';
import TableComponent from '@/components/TableComponent.vue';
import DropdownComponent from '@/components/DropdownComponent.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';

export default {
  name: 'SmsDashboard',
  components: {
    PageHeader,
    Pagination,
    CreateDomainModal,
    DomainValidateModal,
    TableComponent,
    Page,
    DropdownComponent,
    ButtonComponent,
  },
  data() {
    return {
      fields: ['domain', 'valid', 'actions'],
      breadcrumbLinks: {
        1: '/mail/reports/stat',
        2: '/mail/domains',
      },

      domains: [],
      fetched: false,
      pages: 1,
      loading: false,
      currentPage: 1,
      features: [
        { text: 'Lista de contatos' },
        { text: 'Templates customizáveis' },
        { text: 'Relatórios em tempo real' },
        { text: 'Rastreio de cliques, aberturas e leituras de email' },
        { text: 'E muito mais...' },
      ],
    };
  },
  created() {
    this.fetch(1);
    this.$root.$on('domains.update', this.fetch);
  },
  methods: {
    locked() {
      if (this.$store.state.account.plans.email == null) {
        return true;
      }
      return false;
    },
    verify(params) {
      this.$root.$emit('domain.validate', { domain: params });
    },
    fetch(page) {
      this.loading = true;
      this.currentPage = page;
      MailService.getDomains(page).then(
        (response) => {
          console.log(response);
          this.loading = false;
          this.domains = response;
          this.pages = response.last_page;
        },
        (error) => {
          this.content = error;
          console.log(JSON.stringify(error.response.data));
        },
      );
    },
    remove(id) {
      Swal.fire({
        title: this.$t('generic-str.r-sure'),
        text: this.$t('domain.label'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('warnings.btn-y-delete'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          MailService.deleteDomain(id).then(
            () => {
              this.fetch(1);
              Swal.fire(`${this.$t('generic-str.deleted')}!`, this.$t('domain.deleted'), 'success');
            },
            (error) => {
              this.content = error;
            },
          );
        }
      });
    },
    goDetail() {
      this.$router.push('detail');
    },
  },
};
</script>

<style scoped lang="scss">
.btn-search-id {
  height: 35px;
}
.btn-export {
  margin-left: 1px;
  padding: 8px 20px !important;
}
.m-top-10 {
  margin-top: 10px;
}
.no-mail {
  text-align: center;
  font-size: 100px;
  margin: 0px;
  padding: 0px;
  height: 0px;
}
</style>
